import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-ajuda',
  templateUrl: './modal-ajuda.page.html',
  styleUrls: ['./modal-ajuda.page.scss'],
})
export class ModalAjudaPage implements OnInit {

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss();
  }

}
